import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h4 className="footer-title">Адреса</h4>
          <p className="footer-text">
            <strong>Юридический адрес:</strong> Россия, 663310, Красноярский край, г. Норильск, ул. 50 лет Октября, д. 7
          </p>
          <p className="footer-text">
            <strong>Фактический адрес:</strong> г. Норильск, ул. Пушкина, д. 6А; г. Норильск, Молодёжный проезд, д. 23А
          </p>
        </div>
        <div className="footer-section">
          <h4 className="footer-title">Контактные лица</h4>
          <p className="footer-text">
            <strong>Руководитель:</strong> Беляев Игорь Сергеевич
          </p>
          <p className="footer-text">
            <strong>Научный консультант:</strong> Рысеева Ольга Павловна
          </p>
          <p className="footer-text">
            <strong>Студенты:</strong> Самплина Влада Руслановна, Костин Егор Артемович
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 NordHouseMap. Все права защищены.</p>
      </div>
    </footer>
  );
}

export default Footer;
